import React, { lazy, Suspense } from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();

const App = lazy(() => import('containers/App'));
const LandingPage = lazy(() => import('containers/LandingPageContainer/LandingPage'));
const ReviewPage = lazy(() => import('containers/ReviewPageContainer/ReviewPage'));
const RequestReceivedPage = lazy(() =>
  import('containers/RequestReceivedPageContainer/RequestReceivedPage')
);
const GoodNewsPage = lazy(() => import('containers/GoodNewsPageContainer/GoodNewsPage'));
const ErrorPage = lazy(() => import('containers/ErrorPageContainer/ErrorPage'));

export const routes = [
  {
    component: LandingPage,
    exact: true,
    path: '/',
    title: 'Landing Page',
    nextPath: '/review-page',
    failurePath: null,
    backBehaviour: {
      isInternal: true,
      path: '/'
    }
  },
  {
    component: ReviewPage,
    path: '/review-page',
    title: 'Review Page',
    nextPath: '/request-received-page',
    failurePath: null,
    backBehaviour: {
      isInternal: true,
      path: '/'
    }
  },
  {
    component: RequestReceivedPage,
    path: '/request-received-page',
    title: 'Request Received Page',
    nextPath: '/good-news-page',
    failurePath: null
  },
  {
    component: GoodNewsPage,
    path: '/good-news-page',
    title: 'Good News Page',
    nextPath: '/temporary',
    failurePath: null
  },
  {
    component: ErrorPage,
    path: '/error',
    title: 'Error Page',
    nextPath: null,
    failurePath: null
  }
];

export const router = (
  <Router history={history}>
    <Suspense fallback={<div />}>
      <Switch>
        {routes.map(route => {
          return (
            <Route
              key={route.path}
              path={route.path}
              exact={route.exact}
              render={props => <route.component {...props} routes={route.routes} />}
            />
          );
        })}
      </Switch>
    </Suspense>
  </Router>
);
